// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active {
   background-color: rgba(0, 178, 201, .05);
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/document-list/document-list.component.css"],"names":[],"mappings":"AAAA;GACG,wCAAwC;AAC3C","sourcesContent":[".active {\n   background-color: rgba(0, 178, 201, .05);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
